/**
 * @param {"Fixed" | "ARM" | "Variable" | "Other"} loanTypeToCheck
 * @returns {"Fixed" | "ARM" | "Variable"}
 */
const formatLoanType = (loanTypeToCheck) => {
	if (loanTypeToCheck === undefined || loanTypeToCheck === null)
		return 'Fixed';

	const lowerCaseLoanType = loanTypeToCheck.toLowerCase();

	if (lowerCaseLoanType === 'fixed') return 'Fixed';
	if (lowerCaseLoanType === 'arm') return 'ARM';
	if (lowerCaseLoanType === 'variable') return 'Variable';

	return 'Fixed';
};

export default formatLoanType;
